module.exports = __webpack_public_path__ + "img/selected6-min.cd7e4018.png";